import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import { IoClose } from "react-icons/io5";
import { IoDocumentOutline } from "react-icons/io5";
import { FaSave } from "react-icons/fa";
import { GiCrossMark } from "react-icons/gi";
import { IoPrintSharp } from "react-icons/io5";
import LoadingScreen from "../LoadingScreen";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";

const CityMaster = ({ hideNavbar }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const state = useSelector((state) => state.changeTheState);
  const user = state?.user?.emailId?.split("@")[0];
  const location = useLocation();
  const menu = location.state ? location.state.menu : null;
  const authToken = window.sessionStorage.getItem("auth-token");
    const BASEURL_GLOBAL =  process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [countryCode, setCountryCode] = useState("");
  const [countryName, setCountryName] = useState("");
  const [cityCode, setCityCode] = useState("");
  const [cityName, setCityName] = useState("");
  const [long, setLong] = useState(0);
  const [lat, setLat] = useState(0);
  const [rad, setRad] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [selectedRowIndex, setselectedRowIndex] = useState(null);
  const [countryList, setCountryList] = useState([]);
  const [routeList, setRouteList] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=848`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setCountryList(res?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 848", err);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=652`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setRouteList(res?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 652", err);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=596`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        const sortedData = res?.data?.sort((a, b) =>
          String(a.OM_CITY_CODE ?? "").localeCompare(
            String(b.OM_CITY_CODE ?? ""),
            undefined,
            { numeric: true, sensitivity: "base" },
          ),
        );
        setData(res?.data);
        setTableData(sortedData);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 596", err);
      });
  };

  // Adding and Removing from the Grid
  const AddToGrid = () => {
    const newValue = {
      OM_CITY_CODE: cityCode,
      OM_CITY_DESCRIPTION: cityName,
      OM_CITY_COUNTRY_CODE: countryCode,
      OM_CITY_LONGITUDE: long,
      OM_CITY_LATITUDE: lat,
      OM_CITY_RADIUS: rad,
    };
    setTableData([...tableData, newValue]);
    clearAll();
  };

  function clearAll() {
    setCityCode("");
    setCityName("");
    setCountryCode("");
    setCountryName("");
    setLat(0);
    setLong(0);
    setRad(0);
  }

  const RemoveFromGrid = async () => {
    if (tableData.length > 0) {
      const updatedValues = [...tableData];
      if (
        selectedRowIndex !== null &&
        selectedRowIndex >= 0 &&
        selectedRowIndex < updatedValues.length
      ) {
        const isUsedinRoute = routeList?.find(
          (item) =>
            item?.OM_ROUTE_START ===
              updatedValues[selectedRowIndex]?.OM_CITY_CODE ||
            item?.OM_ROUTE_END ===
              updatedValues[selectedRowIndex]?.OM_CITY_CODE,
        );
        if (isUsedinRoute) {
          alert(
            `This ${updatedValues[selectedRowIndex]?.OM_CITY_CODE} Town Code is used in Route Master`,
          );
          return;
        } else {
          updatedValues.splice(selectedRowIndex, 1);
          await Delete();
          setselectedRowIndex(null);
          window.location.reload();
        }
      } else {
        updatedValues.pop();
      }
      setTableData(updatedValues);
      clearAll();
    } else {
      alert("Please add data details First");
    }
  };

  // ********************* SAVE **********************
  async function Save() {
    setIsLoading(true);
    let successCount = 0;
    let successMessage = null;
    let errorCount = 0;
    let errorMessage = null;
    const dataMakes = new Set(data?.map((d) => d?.OM_CITY_CODE));
    const filterMakeNotAdded = tableData?.filter(
      (item) => !dataMakes.has(item?.OM_CITY_CODE),
    );
    for (let i = 0; i < filterMakeNotAdded?.length; i++) {
      const value = filterMakeNotAdded[i];
      try {
        const response = await axios.post(
          `${BASEURL_GLOBAL}/globalSpHandler?spname=108`,
          {
            CITYCODE: value?.OM_CITY_CODE,
            CITYNAME: value?.OM_CITY_DESCRIPTION,
            COUNTRYCODE: value?.OM_CITY_COUNTRY_CODE,
            LONGITUDE: value?.OM_CITY_LONGITUDE,
            LATITUDE: value?.OM_CITY_LATITUDE,
            RADIUS: value?.OM_CITY_RADIUS,
            CREATEDBY: user,
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessiontoken,
            },
          },
        );

        if (response.status === 201) {
          successCount++;
          successMessage = response.data.message;
        } else {
          errorCount++;
          errorMessage = response.data.message;
        }
      } catch (error) {
        setIsLoading(false);
        console.error(`Error while Saving Cities and Towns Master`, error);
        alert(error.response.data.message);
      }
    }
    setIsLoading(false);
    if (successCount == filterMakeNotAdded?.length && successMessage) {
      alert("Cities and Towns Master Saved Successfully");
      window.location.reload();
    }
    if (errorMessage) {
      alert(errorMessage);
    }
  }

  async function Delete() {
    try {
      setIsLoading(true);
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1475`,
        {
          CITYCODE: cityCode ? cityCode : "",
          DELETEDBY: user || "",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );
      if (response.status === 201) {
        alert("Cities and Towns Master Deleted Successfully");
      } else {
        alert("Error While Deleting Cities and Towns Master");
      }
      setIsLoading(false);
    } catch (err) {
      alert("Error While Deleting Cities and Towns Master");
      setIsLoading(false);
    }
  }

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-100vh">
      <section className="block print:hidden">
        {!hideNavbar && <AllPagesNavbar />}
        <header className="header__of__main lg:flex justify-between items-end px-3">
          <h1 className="header__of__page">{"CITIES AND TOWNS MASTER"}</h1>
        </header>

        <div className="flex gap-2 mt-2 items-center text-gray-700 pl-2">
          <IoDocumentOutline
            size={24}
            onClick={() => {
              clearAll();
            }}
            className="text-blue-800  hover:text-blue-900 transition-all duration-200 drop-shadow-md"
          />
          <FaSave
            size={24}
            onClick={async () => {
              await Save();
            }}
            className="text-green-400 hover:text-green-500 transition-all duration-200 drop-shadow-md"
          />
          <GiCrossMark
            size={24}
            className="text-red-400 hover:text-red-500 transition-all duration-200 drop-shadow-md"
          />
          <IoPrintSharp
            size={24}
            className="text-purple-400 hover:text-purple-500 transition-all duration-200 drop-shadow-md"
          />
        </div>

        <div className="lg:flex lg:flex-col text-xs mt-2 justify-between bg-gray-100 p-4 mx-10 rounded-md">
          <aside className="visible lg:h-[300px] p-1 z-0 lg:overflow-auto mt-2">
            <table className="w-auto border border-gray-300 text-sm">
              <thead class="sticky top-0 w-44">
                <tr className="bg-[#2b3f5c] text-white text-[12px]">
                  <td className="text-right py-2 px-4 border border-gray-300 ">S NO</td>
                  <td className="py-2 px-4  border border-gray-300 text-left">CITY CODE</td>
                  <td className="py-2 px-4  border border-gray-300 text-left">CITY NAME</td>
                  <td className="py-2 px-4  border border-gray-300 text-left">COUNTRY CODE</td>
                  <td className="py-2 px-4  border border-gray-300 text-right">LONGITUDE</td>
                  <td className="py-2 px-4  border border-gray-300 text-right">LATITUDE</td>
                  <td className="py-2 px-4  border border-gray-300 text-right">RADIUS</td>
                </tr> 
              </thead>
              <tbody>
                {tableData?.map((row, index) => (
                  <tr
                    className="hover:bg-gray-100 cursor-pointer text-[12px]"
                    key={index}
                    onClick={() => {
                      setCityCode(row?.OM_CITY_CODE);
                      setCityName(row?.OM_CITY_DESCRIPTION);
                      setLong(row?.OM_CITY_LONGITUDE);
                      setLat(row?.OM_CITY_LATITUDE);
                      setRad(row?.OM_CITY_RADIUS);
                      setCountryCode(row?.OM_CITY_COUNTRY_CODE);
                      const country = countryList?.find(
                        (item) =>
                          item?.COUNTRYCODE === row?.OM_CITY_COUNTRY_CODE,
                      );
                      setCountryName(country?.COUNTRYNAME);
                      setselectedRowIndex(index);
                    }}
                  >
                    <td className="py-2 px-4 border border-gray-300 text-right">{index + 1}</td>
                    <td className="py-2 px-4 border border-gray-300 text-left">
                      {row.OM_CITY_CODE ? row.OM_CITY_CODE : "N/A"}
                    </td>
                    <td className="py-2 px-4 border border-gray-300 text-left">
                      {row.OM_CITY_DESCRIPTION ? row.OM_CITY_DESCRIPTION : "0"}
                    </td>
                    <td className="py-2 px-4 border border-gray-300 text-left">
                      {row.OM_CITY_COUNTRY_CODE
                        ? row.OM_CITY_COUNTRY_CODE
                        : "0"}
                    </td>
                    <td className="py-2 px-4 border border-gray-300 text-right">
                      {row.OM_CITY_LONGITUDE ? row.OM_CITY_LONGITUDE : "0"}
                    </td>
                    <td className="py-2 px-4 border border-gray-300 text-right">
                      {row.OM_CITY_LATITUDE ? row.OM_CITY_LATITUDE : "0"}
                    </td>
                    <td className="py-2 px-4 border border-gray-300 text-right">
                      {row.OM_CITY_RADIUS ? row.OM_CITY_RADIUS : "0"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </aside>

          <div className="lg:flex lg:flex-col text-xs mt-3 justify-between bg-gray-100 p-4 m-2 rounded-md">
            <div className="flex justify-between">
              <div className="flex flex-col">
                <p className="text-red-600 ">Town Code:</p>
                <input
                  className="w-48 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
                  type="text"
                  value={cityCode}
                  onChange={(e) => {
                    setCityName(e.target.value);
                    setCityCode(e.target.value);
                  }}
                ></input>
                <p className="text-red-600 ">Town Name:</p>
                <input
                  className="w-48 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
                  type="text"
                  value={cityName}
                  onChange={(e) => setCityName(e.target.value)}
                ></input>
                <p className="text-red-600 ">Country:</p>
                <Select
                  className="w-48 h-7 border rounded-md transition-colors duration-200 focus:border-blue-500"
                  value={
                    countryCode
                      ? { label: countryCode, value: countryCode }
                      : { label: "Select Country", value: "" }
                  }
                  onChange={(e) => {
                    if (e.value !== "") {
                      setCountryCode(e.value);
                      const country = countryList?.find(
                        (item) => item?.COUNTRYCODE === e.value,
                      );
                      setCountryName(country?.COUNTRYNAME);
                    } else {
                      setCountryCode(e.value);
                    }
                  }}
                  options={[
                    { value: "", label: "Select Country" },
                    ...countryList?.map((item) => ({
                      value: item?.COUNTRYCODE,
                      label: item?.COUNTRYCODE,
                    })),
                  ]}
                ></Select>
                <input
                  className="lg:mt-5 w-48 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
                  type="text"
                  readOnly
                  value={countryName}
                ></input>
              </div>
              <div className="flex flex-col mt-1 border-[2px] border-slate-400 p-1">
                <span className="text-sm text-red-500">
                  Tramigo Clients Only
                </span>
                <div className="flex">
                  <label className="lg:ml-2">Longitude:</label>
                  <input
                    className="w-32 h-7 border lg:mt-2 text-right border-black p-2  focus:outline-none focus:border-blue-500"
                    type="number"
                    value={long}
                    onChange={(e) => setLong(e.target.value)}
                  ></input>

                  <label className="lg:ml-2">Radius:</label>
                  <input
                    className="w-32 h-7 lg:mt-2 text-right border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
                    type="number"
                    value={rad}
                    onChange={(e) => setRad(e.target.value)}
                  ></input>
                </div>
                <div className="flex">
                  <label className="lg:ml-2">Latitude:</label>
                  <input
                    className="w-32 h-7 lg:mt-2 text-right lg:ml-4 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
                    type="number"
                    value={lat}
                    onChange={(e) => setLat(e.target.value)}
                  ></input>
                </div>
              </div>
            </div>
            <div className="flex justify-end gap-2 mt-2">
              <button
                className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                onClick={() => {
                  if (!cityCode) {
                    alert("Kindly Supply Town Code");
                    return;
                  } else if (!cityName) {
                    alert("Kindly Supply Town Name");
                    return;
                  } else if (!countryCode) {
                    alert("Kindly Supply Country");
                    return;
                  } else {
                    const city = data?.find(
                      (item) => item?.OM_CITY_CODE === cityCode,
                    );
                    if (city) {
                      alert("This City is available");
                      return;
                    } else {
                      AddToGrid();
                    }
                  }
                }}
              >
                Add
              </button>
              <button
                className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                onClick={() => {
                  RemoveFromGrid();
                }}
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default CityMaster;
